<template>
  <form
    class="form"
    novalidate="novalidate"
    @submit.prevent="submit"
    v-if="isShown"
  >
    <div class="form__step" v-if="showSteps"><span>Шаг {{ currentStep }}</span> из {{ totalSteps }}</div>
    <div class="form__title" v-html="title[currentStep - 1] || ''"></div>
    <div class="form__subtitle" v-if="registerSubtitle && showSteps && currentStep === 2" v-html="registerSubtitle"></div>
    <div class="form__item form__alert" v-if="backendMessage">
      <Alert
        :text="backendMessage"
        state="error"
        no-action
      >
      </Alert>
    </div>
    <div v-show="currentStep === 1" class="form__container">
      <div class="form__item">
        <Field
          label="Электронная почта"
          label-for="email"
          row
        >
          <Input
            v-model="email"
            placeholder="your@email.com"
            id="email"
            name="email"
            type="email"
            class="email"
            :icon-right="!isMobileApp ? 'close-circle-s' : ''"
            disabled
          />
        </Field>
      </div>
      <div v-if="showTelOnStep1" class="form__item">
        <Field
          label="Телефон"
          label-for="tel-step1"
          row
        >
          <div
            class="rr-input rr-input_default rr-input_md"
            :class="{ 'has-error': (showErrors && $v.fields.tel.$error) || isTelError }"
          >
            <input
              ref="telStep1InputEl"
              class="rr-input__el"
              type="tel"
              inputmode="tel"
              autocomplete="tel"
              :value="telRaw"
              placeholder="+7(900) 400 20 01"
              id="tel-step1"
              name="tel"
              :disabled="sending"
              @input="onPhoneStep1Input"
            >
            <div class="rr-input__border"></div>
          </div>
          <template v-slot:msg>
            <div class="color-danger" v-if="showErrors && $v.fields.tel.$error">Введите телефон</div>
            <div class="color-danger" v-else-if="isTelError">Введите телефон в формате +7(900) 400 20 01</div>
          </template>
        </Field>
      </div>
      <div class="form__item">
        <Field
          label="Имя"
          label-for="name"
          row
        >
          <Input
            v-model.trim="fields.name"
            placeholder="Имя"
            id="name"
            name="name"
            :state="
              showErrors && $v.fields.name.$error ? 'error' : null
            "
            :disabled="sending"
          >
          </Input>
          <template v-slot:msg>
            <div class="color-danger" v-if="$v.fields.name.$error">Введите имя</div>
          </template>
        </Field>
      </div>
      <div class="form__item">
        <Field
          label="Фамилия"
          label-for="surname"
          row
        >
          <Input
            v-model.trim="fields.surname"
            placeholder="Фамилия"
            id="surname"
            name="surname"
            :state="
              showErrors && $v.fields.surname.$error ? 'error' : null
            "
            :disabled="sending"
          >
          </Input>
          <template v-slot:msg>
            <div class="color-danger" v-if="$v.fields.surname.$error">Введите фамилию</div>
          </template>
        </Field>
      </div>
      <div class="form__item">
        <Field
          v-show="$root.isDesktop === true"
          label="Дата рождения"
          label-for="date"
          class="birthday"
          row
        >
          <div class="flex items-center">
            <Input
              v-model="fields.date"
              placeholder="ДД.ММ.ГГГГ"
              v-mask="'##.##.####'"
              id="date"
              name="date"
              autocomplete="off"
              icon-right="calendar"
              noStateIcons
              @change="onDateChange(1)"
              @input="onDateChange(1)"
              :state="
                showErrors && $v.fields.date.$error ? 'error' : null
              "
              :disabled="sending"
            >
            </Input>
          </div>
          <template v-slot:msg v-if="showErrors">
            <div class="color-danger" v-if="!$v.fields.date.required">Укажите дату рождения</div>
            <div class="color-danger" v-else-if="!$v.fields.date.isCorrectLength || !$v.fields.date.isDate">Укажите дату рождения в формате ДД.ММ.ГГГГ</div>
            <div class="color-danger" v-else-if="!$v.fields.date.isAgeValid">Возраст должен быть в пределах от 1 до 100 лет</div>
          </template>
        </Field>
        <Field
          v-show="$root.isDesktop === false"
          label="Дата рождения"
          label-for="date"
          class="birthday"
          row
        >
          <div class="flex items-center">
            <Input
              v-model="fields.dateMobile"
              type="date"
              id="date"
              name="date"
              autocomplete="off"
              noStateIcons
              @change="onDateChange(2)"
              @input="onDateChange(2)"
              :state="
                showErrors && $v.fields.dateMobile.$error ? 'error' : null
              "
              :disabled="sending"
            >
            </Input>
          </div>
          <template v-slot:msg v-if="showErrors">
            <div class="color-danger" v-if="!$v.fields.dateMobile.required">Укажите дату рождения</div>
            <div class="color-danger" v-else-if="!$v.fields.dateMobile.isAgeMobileValid">Возраст должен быть в пределах от 1 до 100 лет</div>
          </template>
        </Field>
      </div>
      <div class="form__item">
        <Field
          label="Пол"
          row
        >
          <div class="gender">
            <div
              v-for="item in genders"
              :key="item.value"
            >
              <Radio
                v-model.number="fields.gender"
                :value="item.value"
                :state="
                  showErrors && $v.fields.gender.$error ? 'error' :
                  null
                "
                :disabled="sending"
              >{{ item.label }}</Radio>
            </div>
          </div>
          <template v-slot:msg>
            <div class="color-danger" v-if="$v.fields.gender.$error">Укажите пол</div>
          </template>
        </Field>
      </div>
      <div class="section__group">
          <div class="divider"></div>
        <div class="form__item">
          <Field
            :has-error="showErrors && $v.fields.agreement.$error"
          >
            <Checkbox
              v-model="fields.agreement"
              :disabled="sending"
            >
              <span v-if="!customAgreement">
                С условиями
                <Link
                  text="предоставления услуг"
                  :href="isMobileApp ? docOfertaMobileApp : docOferta"
                  variant="primary"
                  target="_blank"
                ></Link>
                ознакомлен и согласен
              </span>
              <span v-else class="custom-agreement" v-html="customAgreement"></span>
            </Checkbox>
          </Field>
        </div>
        <div class="form__item form__item--checkbox">
          <Field
            :has-error="showErrors && $v.fields.sopd.$error"
          >
            <Checkbox
              v-model="fields.sopd"
              :disabled="sending"
            >
              Согласен на обработку <Link text="персональных данных" :href="personalDataPolicyUrl" variant="primary" target="_blank"></Link>
            </Checkbox>
            <template v-slot:msg>
              <div class="color-danger" v-if="$v.fields.sopd.$error">Необходимо согласие на обработку персональных данных</div>
            </template>
          </Field>
        </div>
        <div class="form__item form__item--checkbox">
          <Field
            :has-error="showErrors && $v.fields.sopdDistribution.$error"
          >
            <Checkbox
              v-model="fields.sopdDistribution"
              :disabled="sending"
            >
              Согласен на обработку персональных данных, <Link text="разрешенных для распространения" :href="distributionPolicyUrl" variant="primary" target="_blank"></Link>
            </Checkbox>
            <template v-slot:msg>
              <div class="color-danger" v-if="$v.fields.sopdDistribution.$error">Необходимо согласие на обработку персональных данных, разрешенных для распространения</div>
            </template>
          </Field>
        </div>
        <div class="form__item form__item--checkbox">
          <Field>
            <Checkbox
              v-model="fields.sopdAdvertisement"
              :disabled="sending"
            >
              Согласен получать информационно-рекламные письма
            </Checkbox>
          </Field>
        </div>
        <div class="form__item">
          <Row align="center">
            <Col :size="{md: '24'}">
              <Button
                text="Продолжить"
                variant="primary"
                size="lg"
                :loading="sending"
                :disabled="!fields.agreement || !fields.sopd || !fields.sopdDistribution || hasErrors || sending"
                wide
                mobile
                @click="nextStep(2)"
              ></Button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <!-- STEP 2 -->
    <div v-show="currentStep === 2" class="form__container form__container_ordered">
      <div v-show="hasAdditionalField('tel')" class="form__item" :style="{ 'order': getFieldOrder('tel') }">
        <div class="form__label form__label_row">
          Номер телефона
          <span v-if="theme === 'RFarm'" class="form__label-tooltip-wrap">
            <Icon
              ref="telTooltipTrigger"
              name="info-circle"
              size="xs"
              class="form__label-info-icon"
            />
            <Dropdown
              trigger="telTooltipTrigger"
              :placement="$root.isDesktop ? 'top-end' : 'top'"
              listeners="click"
              hide-overlay
              auto-width
            >
              <template slot="items">
                <div class="form__tel-tooltip">
                  Номер телефона нужен для участия в промоакциях.
                </div>
              </template>
            </Dropdown>
          </span>
        </div>
        <div class="form__search">
          <div
            v-if="hasAdditionalField('tel')"
            class="rr-input rr-input_default rr-input_md form__tel-input"
            :class="{ 'has-error': (showErrors && $v.fields.tel.$error) || isTelError }"
          >
            <input
              ref="telInputEl"
              class="rr-input__el"
              type="tel"
              inputmode="numeric"
              :value="telRaw"
              placeholder="89001111213"
              id="tel"
              name="tel"
              :disabled="sending"
              @input="onTelInput"
            >
            <div class="rr-input__border"></div>
          </div>
          <div class="error-msg">
            <div class="color-danger" v-if="isTelError">Введите номер телефона в формате 89001111213</div>
          </div>
        </div>
      </div>
      <div v-show="hasAdditionalField('location')" class="form__item" :style="{ 'order': getFieldOrder('location') }">
        <div class="form__label">Место жительства</div>
        <div class="form__search">
          <Input
            v-model.trim="location"
            ref="searchLocation"
            class="organization"
            size="md"
            :placeholder="locationPlaceholder"
            autocomplete="off"
            :clearable="true && !isLocationSet"
            :state="
              (showErrors && $v.fields.location.$error) || isLocationError ? 'error' :
              (isLocationSet ? 'success' : null)
            "
            :disabled="sending"
            @input="locationInput"
            mobile
          ></Input>
          <div class="error-msg">
            <div class="color-danger" v-if="$v.fields.location.$error">Заполните поле</div>
            <div class="color-danger" v-if="isLocationError && !isLocationNoDistrictError">Укажите населенный пункт</div>
            <div class="color-danger" v-if="isLocationError && isLocationNoDistrictError">Укажите район в этом городе</div>
          </div>
          <Dropdown
            trigger="searchLocation"
            :show="showLocationDropdown"
            auto-width
            hide-overlay
          >
            <template slot="items">
              <div>
                <div
                  class="base-dropdown__item"
                  v-for="(item, i) in locationsValues"
                  :key="i"
                >
                  <a
                    class="base-dropdown__link"
                    @click.prevent="setLocation(item)"
                  >
                    <div v-html="item.value"></div>
                  </a>
                </div>
                <div
                  v-if="isLocationNotFound"
                  class="base-dropdown__item"
                >
                  <a
                    class="base-dropdown__link"
                    @click.prevent
                  >
                    <div>Ничего не найдено</div>
                  </a>
                </div>
              </div>
            </template>
          </Dropdown>
        </div>
      </div>
      <div v-show="hasAdditionalField('occupation')" class="form__item" :style="{ 'order': getFieldOrder('occupation') }">
        <div class="form__label">Укажите ваш род занятий</div>
        <div
          v-for="(item, i) in occupation"
          :key="i"
        >
          <Checkbox
            v-model="fields.occupation[i]"
            :state="
              showErrors && occupationError ? 'error' :
              null
            "
            :disabled="sending"
            @input="onOccupationInput"
          >
            {{ item.label }}
          </Checkbox>
        </div>
        <div class="error-msg">
          <div class="color-danger" v-if="occupationError">Выберите один из вариантов</div>
        </div>
      </div>
      <div
        class="form__item"
        :style="{ 'order': getFieldOrder('organization') }"
        v-show="(!hasAdditionalField('occupation') && hasAdditionalField('organization') && this.fields.union === 'Member') || (hasAdditionalField('occupation') && fields.occupation[1] === true) &&(hasAdditionalField('organization'))"
      >
        <div class="form__label">Место работы</div>
        <div class="form__search">
          <Input
            v-model.trim="organization"
            ref="searchOrganization"
            class="organization"
            size="md"
            placeholder="Начните вводить место работы"
            autocomplete="off"
            :clearable="true && !isOrganizationSet"
            :state="
              showErrors && $v.fields.organization.$error ? 'error' :
              (isOrganizationSet ? 'success' : null)
            "
            :disabled="sending"
            @input="organizationInput"
            mobile
          ></Input>
          <Dropdown
            trigger="searchOrganization"
            :show="showDropdown"
            auto-width
            hide-overlay
          >
            <template slot="items">
              <div>
                <div
                  class="base-dropdown__item"
                  v-for="(item, i) in organizationsValues"
                  :key="i"
                >
                  <a
                    class="base-dropdown__link"
                    @click.prevent="setOrganization(item)"
                  >
                    <div v-html="item.value"></div>
                    <div><span v-html="item.data.inn"></span>&nbsp;<span v-html="item.data.address.value"></span></div>
                  </a>
                </div>
                <div
                  v-if="isOrganizationNotFound"
                  class="base-dropdown__item"
                >
                  <a
                    class="base-dropdown__link"
                    @click.prevent
                  >
                    <div>Ничего не найдено</div>
                  </a>
                </div>
              </div>
            </template>
          </Dropdown>
        </div>
      </div>
      <div v-show="hasAdditionalField('union')" class="form__item" :style="{ 'order': getFieldOrder('union') }">
        <div class="form__label" v-html="registerUnionQuestion"></div>
        <div
          v-for="(item, i) in unionLabels"
          :key="i"
        >
          <Radio
            v-model="fields.union"
            :value="item.value"
            :state="
              showErrors && $v.fields.union.$error ? 'error' :
              null
            "
            :disabled="sending"
          >{{ item.label }}</Radio>
        </div>
      </div>
      <div v-show="hasAdditionalField('ticket') && this.fields.union === 'Member'" class="form__item" :style="{ 'order': getFieldOrder('ticket') }">
        <div class="form__label">Введите номер профсоюзного билета</div>
        <div class="form__search">
          <Input
            v-model.trim="fields.ticket"
            placeholder="16 цифр номера указаны на профсоюзной карте"
            v-mask="'#### #### #### ####'"
            id="ticket"
            name="ticket"
            :state="
              (showErrors && $v.fields.ticket.$error) || isTicketError ? 'error' :
              null
            "
            :disabled="sending"
            @input="ticketInput"
          ></Input>
          <div class="error-msg">
            <div class="color-danger" v-if="isTicketError">Введите номер профсоюзного билета</div>
          </div>
        </div>
      </div>
      <div v-show="hasAdditionalField('position')" class="form__item" :style="{ 'order': getFieldOrder('position') }">
        <div class="form__label">Должность</div>
        <div class="form__search">
          <Input
            v-model.trim="fields.position"
            placeholder="Укажите должность"
            name="position"
            :state="(showErrors && $v.fields.position.$error) ? 'error' : null"
            :disabled="sending"
          ></Input>
          <div class="error-msg">
            <div class="color-danger" v-if="showErrors && $v.fields.position.$error">Укажите вашу должность</div>
          </div>
        </div>
      </div>
      <div v-show="hasAdditionalField('foundOut')" class="form__item" :style="{ 'order': getFieldOrder('foundOut') }">
        <div class="form__label">Откуда узнали о демо-программе</div>
        <div class="form__search">
          <Input
            v-model.trim="fields.foundOut"
            placeholder="Откуда узнали"
            name="position"
            :state="(showErrors && $v.fields.foundOut.$error) ? 'error' : null"
            :disabled="sending"
          ></Input>
          <div class="error-msg">
            <div class="color-danger" v-if="showErrors && $v.fields.foundOut.$error">Укажите откуда узнали о демо-программе</div>
          </div>
        </div>
      </div>
      <div v-show="hasAdditionalField('internalCode')" class="form__item" :style="{ 'order': getFieldOrder('internalCode') }">
        <div class="form__label">Внутренний код сотрудника</div>
        <div class="form__search">
          <Input
            v-model.trim="fields.internalCode"
            placeholder="Внутренний код сотрудника"
            name="position"
            :state="(showErrors && $v.fields.internalCode.$error) ? 'error' : null"
            :disabled="sending"
          ></Input>
          <div class="error-msg">
            <div class="color-danger" v-if="showErrors && $v.fields.internalCode.$error">Введите внутренний код сотрудника</div>
          </div>
        </div>
      </div>
      <div v-show="hasAdditionalField('personnelNumber')" class="form__item" :style="{ 'order': getFieldOrder('personnelNumber') }">
        <div class="form__label">Табельный номер</div>
        <div class="form__search">
          <Input
            v-model="fields.personnelNumber"
            placeholder="Табельный номер"
            name="personnelNumber"
            :state="(showErrors && $v.fields.personnelNumber.$error) ? 'error' : null"
            :disabled="sending"
            @input="onPersonnelNumberInput"
          ></Input>
          <div class="error-msg">
            <div class="color-danger" v-if="showErrors && !$v.fields.personnelNumber.required">Введите табельный номер</div>
            <div class="color-danger" v-else-if="showErrors && !$v.fields.personnelNumber.isPersonnelNumberValid">Неверный формат табельного номера</div>
          </div>
        </div>
      </div>
      <div v-show="hasAdditionalField('unionFriend') && this.fields.union === 'NonMember'" class="form__item" :style="{ 'order': getFieldOrder('unionFriend') }">
        <div class="form__label">Являетесь ли вы сторонником партии ЛДПР</div>
        <div
          v-for="(item, i) in unionFriendLabels"
          :key="i"
        >
          <Radio
            v-model="fields.unionFriend"
            :value="item.value"
            :disabled="sending"
          >{{ item.label }}</Radio>
        </div>
      </div>
      <div v-show="hasAdditionalField('region')" class="form__item" :style="{ 'order': getFieldOrder('region') }">
        <div class="form__label">{{ regionLabel }}</div>
          <Select
            :options="regionItems"
            v-model="selectedRegion"
            :placeholder="regionLabel"
            @input="onRegionChange"
            :state="(showErrors && $v.selectedRegion.$error) ? 'error' : null"
            :disabled="sending"
          />
          <div class="error-msg">
            <div class="color-danger" v-if="showErrors && $v.selectedRegion.$error">Выберите из списка</div>
          </div>
      </div>
      <div v-show="hasAdditionalField('division') && ((theme === 'FirstBit' && getDivisionItems().length > 0) || (theme === 'KFK' && getDivisionItems().length > 0) || (theme === 'RC' && getDivisionItems().length > 0) || (selectedRegion && getDivisionItems(selectedRegion).length > 0))" class="form__item" :style="{ 'order': getFieldOrder('division') }">
        <div class="form__label">{{ divisionLabel }}</div>
          <Select
            :options="(theme === 'FirstBit' || theme === 'KFK' || theme === 'RC') ? getDivisionItems() : getDivisionItems(selectedRegion)"
            v-model="fields.divisionId"
            :placeholder="divisionLabel"
            :state="(showErrors && $v.fields.divisionId.$error) ? 'error' : null"
            :disabled="sending"
          />
          <div class="error-msg">
            <div class="color-danger" v-if="showErrors && $v.fields.divisionId.$error">{{ divisionErrorMessage }}</div>
          </div>
      </div>
      <div v-show="hasAdditionalField('ministry')" class="form__item" :style="{ 'order': getFieldOrder('ministry') }">
        <div class="form__label">Выберите министерство</div>
          <Select
            :options="ministries"
            v-model="fields.ministryId"
            placeholder="Выберите министерство"
            :state="(showErrors && $v.fields.ministryId.$error) ? 'error' : null"
            :disabled="sending"
          />
          <div class="error-msg">
            <div class="color-danger" v-if="showErrors && $v.fields.ministryId.$error">Выберите министерство</div>
          </div>
      </div>
      <div v-show="hasAdditionalField('hobby')" class="form__item" :style="{ 'order': getFieldOrder('hobby') }">
        <div class="form__label">{{ hobbyLabel }}</div>
        <div class="form__search">
          <Input
            v-model.trim="fields.hobby"
            :placeholder="hobbyLabel"
            name="hobby"
            :disabled="sending"
          ></Input>
          <!-- Поле hobby необязательное, ошибки валидации не показываем -->
        </div>
      </div>
      <div v-show="hasAdditionalField('cityDistrict')" class="form__item" :style="{ 'order': getFieldOrder('cityDistrict') }">
        <div class="form__label">{{ cityDistrictLabel }}</div>
          <Select
            :options="cityDistrictItems"
            v-model="fields.cityDistrict"
            :placeholder="cityDistrictLabel"
            :state="(showErrors && $v.fields.cityDistrict.$error) ? 'error' : null"
            :disabled="sending"
          />
          <div class="error-msg">
            <div class="color-danger" v-if="showErrors && $v.fields.cityDistrict.$error">Выберите район</div>
          </div>
      </div>
      <div v-show="hasAdditionalField('director')" class="form__item" :style="{ 'order': getFieldOrder('director') }">
        <div class="form__label">Являетесь ли вы руководителем</div>
          <div class="gender">
            <div
              v-for="item in directorLabels"
              :key="item.value"
            >
              <Radio
                v-model="fields.director"
                :value="item.value"
                :disabled="sending"
              >{{ item.label }}</Radio>
            </div>
          </div>
        </div>
      <div class="section__group">
        <div class="form__item">
          <div class="divider"></div>
        </div>
        <div class="form__item">
          <Row align="center">
            <Col :size="{md: '24'}">
              <Button
                text="Продолжить"
                variant="primary"
                size="lg"
                type="submit"
                :loading="sending"
                :disabled="!fields.agreement || hasErrors"
                wide
                mobile
              ></Button>
            </Col>
          </Row>
        </div>
      </div>
    </div>

    <Modal
      :active="teamOffLimits"
      name="TeamOffLimitsModal"
      title="Ваша команда уже собрана"
      :subtitle="teamOffLimitsSubtitle"
      icon="info-circle"
      @close.prevent="onTeamOffLimitsClose"
    >
      <Button
        variant="secondary"
        size="lg"
        mobile
        @click="onTeamOffLimitsClose"
      >
        Понятно
      </Button>
    </Modal>

  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import { validationMixin } from 'vuelidate';
import { required, sameAs, requiredIf } from 'vuelidate/lib/validators';
import { mask } from 'vue-the-mask';
import Debounce from 'lodash/debounce';
import Cookies from 'js-cookie';
import Alert from '@rr-component-library/alert/src/main';
import Field from '@rr-component-library/field/src/main';
import Input from '@rr-component-library/input/src/main';
import Radio from '@rr-component-library/radio/src/main';
import Checkbox from '@rr-component-library/checkbox/src/main';
import Select from '@rr-component-library/select/src/main';
import Link from '@rr-component-library/link/src/main';
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import regionsLemana from '@/assets/data/regionsLemana';
import divisionsLemana from '@/assets/data/divisionsLemana';
import regionsMagnit from '@/assets/data/regionsMagnit';
import regionsMegafon from '@/assets/data/regionsMegafon';
import divisionsMagnit from '@/assets/data/divisionsMagnit';
import divisionsFirstBit from '@/assets/data/divisionsFirstBit';
import ministriesMosreg from '@/assets/data/ministriesMosreg';
import hobbyKFK from '@/assets/data/hobbyKFK';
import divisionsKFK from '@/assets/data/divisionsKFK';
import districtsSPB from '@/assets/data/districtsSPB';
import divisionsPharmeco from '@/assets/data/divisionsPharmeco';
import servicesPharmeco from '@/assets/data/servicesPharmeco';
import divisionsRC from '@/assets/data/divisionsRC';

const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

const isCorrectLength = (value) => value !== null && value.length === 10;
const isDate = (value) => dayjs(value, 'DD.MM.YYYY', true).isValid() === true;
const isDateMobile = (value) => dayjs(value, 'YYYY-MM-DD', true).isValid() === true;
const isAgeValid = (value) => dayjs(value, 'DD.MM.YYYY', true) >= dayjs().subtract(100, 'year') && dayjs(value, 'DD.MM.YYYY', true) <= dayjs().subtract(1, 'year');
const isAgeMobileValid = (value) => dayjs(value, 'YYYY-MM-DD', true) >= dayjs().subtract(100, 'year') && dayjs(value, 'YYYY-MM-DD', true) <= dayjs().subtract(1, 'year');
const isPersonnelNumberValid = (value) => /^\d{8}$/.test(String(value || ''));

export default {
  name: 'PersonalInfo',
  mixins: [validationMixin],
  directives: { mask },
  components: {
    Alert,
    Field,
    Input,
    Radio,
    Checkbox,
    Select,
    Link,
    Dropdown,
  },
  props: {
    isShown: Boolean,
    isMobileApp: Boolean,
  },
  data() {
    return {
      showErrors: false,
      sending: false,
      backendMessage: null,
      email: '',
      fields: {
        surname: null,
        name: null,
        date: null,
        dateMobile: null,
        gender: null,
        agreement: false,
        sopd: false,
        sopdDistribution: false,
        sopdAdvertisement: false,
        occupation: [false, false, false, false, false],
        organization: null,
        location: null,
        tel: null,
        union: null,
        unionFriend: null,
        ticket: null,
        position: null,
        foundOut: null,
        personnelNumber: null,
        divisionId: null,
        director: 'false',
        ministryId: null,
        hobby: null,
        cityDistrict: null,
      },
      directorLabels: [
        {
          label: 'Да',
          value: 'true',
        },
        {
          label: 'Нет',
          value: 'false',
        },
      ],
      genders: [
        {
          label: 'Мужской',
          value: 'Male',
        },
        {
          label: 'Женский',
          value: 'Female',
        },
      ],
      occupation: [
        {
          label: 'Школьник или Студент',
          value: 'student',
        },
        {
          label: 'Трудоустроен',
          value: 'employed',
        },
        {
          label: 'Самозанятый',
          value: 'self-employed',
        },
        {
          label: 'На пенсии',
          value: 'retiree',
        },
        {
          label: 'Временно нетрудоустроен',
          value: 'unemployed',
        },
      ],
      union: {
        MGO: [
          {
            label: 'Да',
            value: 'Member',
          },
          {
            label: 'Нет, я друг/родственник',
            value: 'NonMember',
          },
        ],
        LDPR: [
          {
            label: 'Да',
            value: 'Member',
          },
          {
            label: 'Нет',
            value: 'NonMember',
          },
        ],
      },
      title: [
        'Регистрация участника',
        'Ещё пара вопросов',
      ],
      selectedRegion: null,
      selectedDevision: null,
      showSteps: true,
      currentStep: 1,
      organization: null,
      organizationsValues: [],
      isOrganizationSet: false,
      isOrganizationNotFound: false,
      location: null,
      locationsValues: [],
      isLocationSet: false,
      isLocationError: false,
      isLocationNoDistrictError: false,
      isLocationNotFound: false,
      debouncedDoSearch: null,
      debouncedDoSearch2: null,
      showDropdown: false,
      showLocationDropdown: false,
      occupationError: false,
      isTelError: false,
      isTicketError: false,
      teamOffLimits: false,
      internalCode: null,
      telRaw: '',
    };
  },
  validations: {
    fields: {
      surname: {
        required,
      },
      name: {
        required,
      },
      date: {
        required: requiredIf(function f() {
          return this.currentStep === 1;
        }),
        isCorrectLength,
        isDate,
        isAgeValid,
      },
      dateMobile: {
        required: requiredIf(function f() {
          return this.currentStep === 1;
        }),
        isDateMobile,
        isAgeMobileValid,
      },
      gender: {
        required,
      },
      agreement: {
        sameAs: sameAs(() => true),
      },
      sopd: {
        required: requiredIf(function f() {
          return this.currentStep === 1;
        }),
        sameAs: sameAs(() => true),
      },
      sopdDistribution: {
        required: requiredIf(function f() {
          return this.currentStep === 1;
        }),
        sameAs: sameAs(() => true),
      },
      sopdAdvertisement: {
        // Необязательное поле - валидация не требуется
      },
      occupation: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('occupation') && this.currentStep === 2;
        }),
      },
      organization: {
        required: requiredIf(function f() {
          return this.isOrganizationRequired();
        }),
      },
      location: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('location') && this.currentStep === 2;
        }),
      },
      tel: {
        required: requiredIf(function f() {
          if (this.showTelOnStep1 && this.currentStep === 1) return true;
          return this.hasAdditionalField('tel') && this.currentStep === 2 && !this.isFieldOptional('tel');
        }),
      },
      union: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('union') && this.currentStep === 2;
        }),
      },
      unionFriend: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('unionFriend') && this.fields.union === 'NonMember' && this.currentStep === 2;
        }),
      },
      ticket: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('ticket') && this.fields.union === 'Member' && this.currentStep === 2;
        }),
      },
      position: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('position') && this.currentStep === 2;
        }),
      },
      foundOut: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('foundOut') && this.currentStep === 2;
        }),
      },
      internalCode: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('internalCode') && this.currentStep === 2;
        }),
      },
      personnelNumber: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('personnelNumber') && this.currentStep === 2;
        }),
        isPersonnelNumberValid(value) {
          if (!this.hasAdditionalField('personnelNumber') || this.currentStep !== 2) return true;
          return isPersonnelNumberValid(value);
        },
      },
      divisionId: {
        required: requiredIf(function f() {
          if (this.theme === 'RC') return false;
          return this.hasAdditionalField('division') && this.currentStep === 2 && (!this.hasAdditionalField('region')
            || (this.hasAdditionalField('region') && this.selectedRegion && this.getDivisionItems(this.selectedRegion).length > 0)
            || (this.theme === 'KFK' && this.getDivisionItems().length > 0));
        }),
      },
      ministryId: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('ministry') && this.currentStep === 2;
        }),
      },
      hobby: {
        // Необязательное поле - валидация не требуется
      },
      cityDistrict: {
        required: requiredIf(function f() {
          return this.hasAdditionalField('cityDistrict') && this.currentStep === 2;
        }),
      },
    },
    selectedRegion: {
      required: requiredIf(function f() {
        return this.hasAdditionalField('region') && this.currentStep === 2;
      }),
    },
  },
  computed: {
    ...mapGetters('settings', ['theme', 'isPrivate', 'options', 'resources']),
    ...mapGetters('user', ['questionnaire', 'questionnaireStatus', 'questionnaireErrorCode', 'questionnaireErrorDetail', 'accessAttributes', 'extendedAuthChangeEmailStatus']),
    ...mapGetters('dadata', ['organizations', 'address', 'responseStatus']),
    ...mapGetters('marketingProgramDocuments', ['personalDataPolicy', 'distributionPolicy', 'offerDocument']),
    additionalFields() {
      if (!this.options || !this.options.additionalFields) return {};
      return this.options.additionalFields;
    },
    hasErrors() {
      return !!(this.showErrors && this.$v.$anyError);
    },
    totalSteps() {
      let steps = 1;
      if (this.showSteps) {
        if (this.showRegisterAdditionalStep) steps += 1;
        if (this.isTeamsEnabled && (!this.isTeamStepHidden || this.isTeamStepRequired) && !this.isPrivate) steps += 1;
      }
      return steps;
    },
    showRegisterAdditionalStep() {
      return this.options ? this.options.showRegisterAdditionalStep === true : false;
    },
    showTelOnStep1() {
      return this.options ? this.options.showTelOnStep1 === true : false;
    },
    isTeamsEnabled() {
      return this.options ? this.options.isTeamsEnabled === true : false;
    },
    isTeamStepRequired() {
      return this.options ? this.options.isTeamStepRequired === true : false;
    },
    isTeamStepHidden() {
      return this.options ? this.options.isTeamStepHidden === true || false : false;
    },
    saveCityDistrictForHomeAreaId() {
      return this.options ? this.options.saveCityDistrictForHomeAreaId || '' : '';
    },
    locationsBoost() {
      return this.options ? this.options.locationsBoost || [] : [];
    },
    customAgreement() {
      return this.options ? this.replaceVariables(this.options.customAgreement) || '' : '';
    },
    registerSubtitle() {
      return this.resources ? this.resources.registerSubtitle || '' : '';
    },
    registerUnionQuestion() {
      return this.resources ? this.resources.registerUnionQuestion || '' : '';
    },
    docOferta() {
      return this.offerDocument || '#';
    },
    docOfertaMobileApp() {
      return `/openInExternal?url=${this.docOferta}`;
    },
    supportEmail() {
      return this.resources ? this.resources.supportEmail || '#' : '#';
    },
    supportEmailText() {
      return this.resources ? this.resources.supportEmailText || '' : '';
    },
    currentAdditionalFields() {
      if (!this.additionalFields) return {};
      return this.additionalFields;
    },
    locationPlaceholder() {
      return this.resources ? this.resources.locationPlaceholder || 'Начните вводить название населенного пункта' : '';
    },
    unionLabels() {
      if (!this.union[this.theme]) {
        return [
          {
            label: 'Да',
            value: 'Member',
          },
          {
            label: 'Нет',
            value: 'NonMember',
          },
        ];
      }
      return this.union[this.theme];
    },
    unionFriendLabels() {
      return [
        {
          label: 'Да',
          value: 'Friend',
        },
        {
          label: 'Нет',
          value: 'NonFriend',
        },
      ];
    },
    unionFriendIsMember() {
      const values = { LDPR: true };
      return values[this.theme] === true || false;
    },
    regionLabel() {
      if (this.theme === 'Lemana') return 'Выбрать регион';
      if (this.theme === 'Magnit') return 'Выбрать подразделение';
      if (this.theme === 'Pharmeco') return 'Выбрать подразделение';
      if (this.theme === 'FirstBit') return 'Выбрать регион';
      return 'Выбрать регион';
    },
    regionItems() {
      if (this.theme === 'Lemana') return regionsLemana;
      if (this.theme === 'Magnit') return regionsMagnit;
      if (this.theme === 'Pharmeco') return divisionsPharmeco;
      if (this.theme === 'Megafon') return regionsMegafon;
      if (this.theme === 'FirstBit') return regionsLemana; // Assuming FirstBit uses Lemana regions for now
      return [];
    },
    divisionLabel() {
      if (this.theme === 'Lemana') return 'Выбрать подразделение';
      if (this.theme === 'Magnit') return 'Уточните выбор';
      if (this.theme === 'Pharmeco') return 'Служба';
      if (this.theme === 'FirstBit') return 'Выбрать филиал';
      if (this.theme === 'KFK') return 'Служба';
      if (this.theme === 'RC') return 'Мой Беговой центр';
      return '';
    },
    divisionErrorMessage() {
      if (this.theme === 'RC') return 'Выберите беговой центр';
      return 'Выберите подразделение';
    },
    divisions() {
      if (this.theme === 'Lemana') return divisionsLemana;
      if (this.theme === 'Magnit') return divisionsMagnit;
      if (this.theme === 'Pharmeco') return servicesPharmeco;
      if (this.theme === 'FirstBit') return divisionsFirstBit;
      if (this.theme === 'KFK') return divisionsKFK;
      if (this.theme === 'RC') return divisionsRC;
      return [];
    },
    ministries() {
      if (this.theme === 'Mosreg') return ministriesMosreg;
      return [];
    },
    hobbyLabel() {
      if (this.theme === 'KFK') return 'Хобби или любимый спорт';
      return 'Хобби или любимый спорт';
    },
    hobbyItems() {
      if (this.theme === 'KFK') return hobbyKFK;
      return [];
    },
    cityDistrictItems() {
      const fieldConfig = this.additionalFields?.cityDistrict;
      if (fieldConfig?.dataSource === 'districtsSPB') {
        return districtsSPB;
      }
      return [];
    },
    cityDistrictLabel() {
      return 'Выберите район';
    },
    teamOffLimitsSubtitle() {
      return `На данный момент в вашей команде нет свободных мест для принятия участия. Свяжитесь с организатором Программы в вашей компании или напишите нам в техническую поддержку<br/>
      <a href="mailto:${this.supportEmail}">${this.supportEmailText || this.supportEmail}</a>`;
    },
    isSpecialSettingsMp() {
      return this.options ? this.options.isSpecialSettingsMp === true : false;
    },
    isClubEnabled() {
      return this.options ? this.options.isClubEnabled === true : false;
    },
    phoneMaskEnabled() {
      // Сначала проверяем настройку в options
      if (this.options && this.options.phoneMaskEnabled !== undefined) {
        return this.options.phoneMaskEnabled !== false;
      }
      // Если настройка не задана в options, проверяем конфигурацию поля
      const telField = this.currentAdditionalFields.tel;
      if (telField && telField.mask !== undefined) {
        return telField.mask;
      }
      // По умолчанию маска включена
      return true;
    },
    personalDataPolicyUrl() {
      return this.personalDataPolicy || '#';
    },
    distributionPolicyUrl() {
      return this.distributionPolicy || '#';
    },
  },
  watch: {
    isShown(val) {
      if (val) {
        this.showErrors = false;
        this.sending = false;
      }
    },
    currentStep(val) {
      if ((val === 1 && this.showTelOnStep1) || (val === 2 && this.hasAdditionalField('tel'))) {
        this.telRaw = this.fields.tel ?? '';
      }
    },
  },
  methods: {
    ...mapActions('user', ['getQuestionnaire', 'createQuestionnaire', 'applyAnswers', 'completeQuestionnaire', 'logout', 'changeEmail']),
    ...mapActions('dadata', ['searchOrganization', 'searchAddress']),
    ...mapActions('marketingProgramDocuments', ['getMarketingProgramDocuments']),
    onTelInput(e) {
      this.isTelError = false;
      const raw = e && e.target ? e.target.value : '';
      let digits = String(raw).replace(/\D/g, '');
      if (digits.startsWith('7')) digits = `8${digits.slice(1)}`;
      digits = digits.slice(0, 11);
      if (digits.length > 0 && digits[0] !== '8') digits = `8${digits.slice(0, 10)}`;
      this.fields.tel = digits;
      this.telRaw = digits;
      this.$nextTick(() => {
        const el = this.$refs.telInputEl;
        if (el && el.value !== digits) {
          el.value = digits;
        }
      });
    },
    formatPhoneStep1(digits) {
      const rest = String(digits || '').replace(/\D/g, '').replace(/^7/, '').slice(0, 10);
      let formatted = '+7';
      if (rest.length === 0) return formatted;
      formatted += `(${rest.slice(0, 3)}`;
      if (rest.length < 3) return formatted;
      formatted += ')';
      if (rest.length > 3) formatted += ` ${rest.slice(3, 6)}`;
      if (rest.length > 6) formatted += ` ${rest.slice(6, 8)}`;
      if (rest.length > 8) formatted += ` ${rest.slice(8, 10)}`;
      return formatted;
    },
    onPhoneStep1Input(e) {
      this.isTelError = false;
      this.backendMessage = null;
      let digits = String((e && e.target && e.target.value) || '').replace(/\D/g, '');
      if (digits.startsWith('8')) digits = `7${digits.slice(1)}`;
      if (digits.length > 0 && !digits.startsWith('7')) digits = `7${digits}`;
      digits = digits.slice(0, 11);
      const formatted = this.formatPhoneStep1(digits);
      this.telRaw = formatted;
      this.fields.tel = digits.length === 11 ? `+${digits}` : null;
      this.$nextTick(() => {
        const el = this.$refs.telStep1InputEl;
        if (el && el.value !== formatted) el.value = formatted;
      });
    },
    getStep1Data() {
      const { fields } = this;
      const result = {
        LastName: fields.surname,
        FirstName: fields.name,
        Birthday: this.$root.isDesktop === true ? this.formatDate(fields.date) : fields.dateMobile,
        Gender: fields.gender,
        SOPD: fields.agreement.toString(),
        SOPDDistribution: fields.sopd.toString(),
        SOPDOffer: fields.sopdDistribution.toString(),
        SOPDAdvertisement: fields.sopdAdvertisement.toString(),
      };
      if (fields.tel) {
        result.Phone = String(fields.tel).replaceAll(' ', '');
      }
      return result;
    },
    goToStep(step) {
      this.showErrors = false;
      if (this.showRegisterAdditionalStep) {
        this.organizationsValues = [];
        this.isOrganizationSet = false;
        this.isOrganizationNotFound = false;
        this.showDropdown = false;
        this.showLocationDropdown = false;
        this.currentStep = step;
      } else if (this.isTeamsEnabled && !this.isTeamStepHidden && !this.isPrivate && this.isTeamStepRequired) {
        this.currentStep = step;
      } else {
        this.submit();
      }
    },
    nextStep(step) {
      this.showErrors = true;
      this.isTelError = false;
      this.backendMessage = null;
      if (this.showTelOnStep1 && this.currentStep === 1 && !this.checkTel()) {
        this.isTelError = true;
      }
      this.$v.$touch();
      if (this.hasErrors || this.isTelError) {
        return;
      }

      if (this.showTelOnStep1 && this.currentStep === 1 && this.fields.tel) {
        this.sending = true;
        this.applyAnswers(this.getStep1Data())
          .then(() => {
            this.sending = false;
            if (this.questionnaireStatus === 204 || this.questionnaireStatus === 200) {
              this.goToStep(step);
              return;
            }
            if (this.isPhoneTakenError()) {
              this.backendMessage = 'Этот номер привязан к другому профилю. Используйте другой номер';
              return;
            }
            this.backendMessage = `Произошла ошибка: ${this.questionnaireStatus}`;
          });
        return;
      }

      this.goToStep(step);
    },
    onRegionChange() {
      // Сбросить выбор подразделения при изменении региона
      this.fields.divisionId = null;
    },
    getDivisionItems(regionId) {
      // Фильтруем подразделения по regionId
      if (this.theme === 'FirstBit' || this.theme === 'KFK' || this.theme === 'RC') {
        return this.divisions;
      }
      return this.divisions.filter((division) => division.regionId === regionId);
    },
    setClearHandlers() {
      const iconEmail = document.querySelector('.email .rr-input__icons .rr-input__icon:last-child');
      if (iconEmail) {
        iconEmail.addEventListener('click', this.resetEmail);
      }
      const iconOrganization = document.querySelector('.organization .rr-input__icons .rr-input__icon:last-child');
      if (iconOrganization) {
        iconOrganization.addEventListener('click', this.resetOrganization);
      }
    },
    checkQuestionnaire() {
      this.getQuestionnaire()
        .then(() => {
          if (this.questionnaireStatus === 200) {
            if (this.questionnaire.state === 'Created') {
              this.setData();
            } else if (this.questionnaire.state === 'Completed') {
              this.setData();
              this.sending = true;
              setTimeout(() => { this.checkQuestionnaire(); }, 2000);
            } else if (this.questionnaire.state === 'Approved') {
              if (this.isMobileApp) {
                // Приводим поведение WebView к веб-логике: открываем Team только когда шаг команды обязателен
                // и действительно требуется выбор команды (см. isNeedToSelectTeam)
                const teamRequired = this.isTeamsEnabled && !this.isTeamStepHidden && !this.isPrivate && this.isTeamStepRequired;
                const shouldOpenTeam = teamRequired && this.isNeedToSelectTeam();
                if (shouldOpenTeam) {
                  this.$router.push({ name: 'Team' }).catch(() => {});
                  return;
                }
                this.$router.push({ name: 'RegisterComplete' }).catch(() => {});
                return;
              }
              if (this.isClubEnabled && this.isTeamsEnabled && this.isPrivate) {
                this.$router.push({ name: 'Club', query: { isFirstLogin: 'true' } }).catch(() => {});
              } else if (this.isClubEnabled && this.isNeedToSelectTeam()) {
                this.$router.push({ name: 'Team' }).catch(() => {});
              } else if (this.isClubEnabled) {
                this.$router.push({ name: 'Club', query: { isFirstLogin: 'true' } }).catch(() => {});
              }
              this.sending = false;
              if (this.isTeamsEnabled && this.isPrivate) {
                this.$router.push({ name: 'Dashboard', query: { isFirstLogin: 'true' } }).catch(() => {});
              } else if (this.isNeedToSelectTeam()) {
                this.$router.push({ name: 'Team' }).catch(() => {});
              } else {
                this.$router.push({ name: 'Dashboard', query: { isFirstLogin: 'true' } }).catch(() => {});
              }
              this.sending = false;
            }
          } else if (this.questionnaireStatus === 404) {
            this.createQuestionnaire()
              .then(() => {
                if (this.questionnaireStatus === 201) {
                  this.getQuestionnaire()
                    .then(() => {
                      this.setData();
                    });
                }
              });
          } else if (this.questionnaireStatus === 401) {
            this.$router.push({ name: 'Auth' }).catch(() => {});
          }
        });
    },
    // Получение accessAttributes для SSO
    getAccessAttributes() {
      let accessAttributes = [];
      try {
        const storedAttributes = sessionStorage.getItem('ssoAccessAttributes');
        if (storedAttributes) accessAttributes = JSON.parse(storedAttributes);
      } catch (e) { /* ignore */ }
      if (!Array.isArray(accessAttributes) || accessAttributes.length === 0) {
        accessAttributes = Array.isArray(this.accessAttributes) ? [...this.accessAttributes] : [];
      }
      return accessAttributes;
    },

    // Настройка данных из VK SSO
    setupVKData(accessAttributes) {
      // Получаем данные из accessAttributes (данные из VK)
      this.email = this.getAttributeByKey(accessAttributes, 'EmailAddress') || this.getAttributeByKey(accessAttributes, 'email');
      this.fields.surname = this.getAttributeByKey(accessAttributes, 'LastName') || this.getAttributeByKey(accessAttributes, 'lastName');
      this.fields.name = this.getAttributeByKey(accessAttributes, 'FirstName') || this.getAttributeByKey(accessAttributes, 'firstName');
      this.fields.date = this.convertDateVK(this.getAttributeByKey(accessAttributes, 'Birthday') || this.getAttributeByKey(accessAttributes, 'birthday'));
      this.fields.dateMobile = this.fields.date ? dayjs(this.fields.date, 'DD.MM.YYYY', true).format('YYYY-MM-DD') : null;
      this.fields.gender = this.getAttributeByKey(accessAttributes, 'Gender') || this.getAttributeByKey(accessAttributes, 'gender');

      // Если email не найден в атрибутах, попробуем извлечь из JWT токена
      if (!this.email) {
        // Пробуем получить токен из разных источников
        const token = this.accessToken || Cookies.get('token');
        if (token) {
          this.email = this.extractEmailFromJwt(token);
        }
      }

      // Автоматически регистрируем email для VK SSO
      if (this.email) {
        this.registerVKEmail();
      }
    },

    // Настройка данных из общего SSO
    setupSSOData(accessAttributes) {
      if (accessAttributes.length > 0) {
        sessionStorage.setItem('ssoAccessAttributes', JSON.stringify(accessAttributes));
        const attrEmail = this.getAttributeByKey(accessAttributes, 'EmailAddress') || this.getAttributeByKey(accessAttributes, 'email') || '';
        this.email = (attrEmail || this.getAnswerByKey('EmailAddress') || '').toLowerCase();
        this.fields.surname = this.getAttributeByKey(accessAttributes, 'LastName') || null;
        this.fields.name = this.getAttributeByKey(accessAttributes, 'FirstName') || null;
        const rrBirthDate = this.getAttributeByKey(accessAttributes, 'BirthDate');
        const vkBirthday = this.getAttributeByKey(accessAttributes, 'Birthday') || this.getAttributeByKey(accessAttributes, 'birthday');
        if (rrBirthDate) {
          this.fields.date = this.convertDateRR(rrBirthDate);
        } else if (vkBirthday) {
          this.fields.date = this.convertDateVK(vkBirthday);
        } else {
          this.fields.date = null;
        }
        this.fields.dateMobile = this.fields.date ? dayjs(this.fields.date, 'DD.MM.YYYY', true).format('YYYY-MM-DD') : null;
        this.fields.gender = this.getAttributeByKey(accessAttributes, 'Gender') || null;
        return true;
      }
      return false;
    },

    // Настройка общих данных (не SSO)
    setupCommonData() {
      // Prefill from localStorage if present (email registration flow)
      const lsEmail = (localStorage.getItem('authEmail') || '').trim();
      if (lsEmail) {
        this.email = lsEmail.toLowerCase();
      } else {
        this.email = this.getAnswerByKey('EmailAddress');
      }

      // Не перезаписываем поля, если они уже заполнены (например, из URL параметров)
      if (!this.fields.surname) {
        this.fields.surname = this.getAnswerByKey('LastName') || null;
      }
      if (!this.fields.name) {
        this.fields.name = this.getAnswerByKey('FirstName') || null;
      }
      if (!this.fields.date) {
        this.fields.date = this.convertDate(this.getAnswerByKey('Birthday')) || null;
        this.fields.dateMobile = dayjs(this.fields.date, 'DD.MM.YYYY', true).format('YYYY-MM-DD');
      }
      if (!this.fields.gender) {
        this.fields.gender = this.getAnswerByKey('Gender') || null;
      }
      if (!this.fields.personnelNumber) {
        this.fields.personnelNumber = this.getAnswerByKey('PersonnelNumber') || null;
      }

      if (this.questionnaire.state === 'Completed' || this.questionnaire.state === 'Approved') {
        this.fields.agreement = true;
      }
    },

    setData() {
      const fromSSO = sessionStorage.getItem('authFromSSO') === 'true';
      const fromVK = sessionStorage.getItem('vkAuth') === 'true';

      // Сначала проверяем URL параметры для мобильного приложения
      this.parseMobileAppParams();

      // Получаем accessAttributes для всех SSO (приоритет: sessionStorage -> store)
      const accessAttributes = this.getAccessAttributes();

      // Если это VK SSO, предзаполняем данные из профиля (приоритет над общим SSO)
      if (fromVK) {
        this.setupVKData(accessAttributes);
        return;
      }

      if (fromSSO) {
        if (this.setupSSOData(accessAttributes)) {
          return;
        }
      }

      // Настройка общих данных
      this.setupCommonData();
    },
    async registerVKEmail() {
      try {
        const token = sessionStorage.getItem('extendedAuthToken');
        if (!token) {
          return;
        }
        await this.changeEmail({
          token,
          emailAddress: this.email,
        });

        if (this.extendedAuthChangeEmailStatus === 200) {
          // После регистрации email переходим к вводу кода
          this.extendedAuthStep = 'code-required';
          this.startDate = new Date(Date.now() + 60000).toISOString();
          this.updateCountdown();
          setTimeout(() => { this.setInputs(); }, 100);
        }
      } catch (error) {
        // Игнорируем ошибки регистрации email для VK SSO
      }
    },
    getData() {
      const { fields } = this;
      const result = {
        LastName: fields.surname,
        FirstName: fields.name,
        Birthday: this.$root.isDesktop === true ? this.formatDate(fields.date) : fields.dateMobile,
        Gender: fields.gender,
      };
      if (this.isPrivate) {
        const invitationTeamId = sessionStorage.getItem('invitationTeamId');
        if (invitationTeamId) result.TeamId = invitationTeamId;
      }
      if (this.showTelOnStep1 && fields.tel) {
        result.Phone = String(fields.tel).replaceAll(' ', '');
      }
      if (this.showRegisterAdditionalStep) {
        if (this.hasAdditionalField('occupation')) {
          result.IsStudent = fields.occupation[0].toString();
          result.IsEmployed = fields.occupation[1].toString();
          result.IsSelfEmployed = fields.occupation[2].toString();
          result.IsRetiree = fields.occupation[3].toString();
          result.IsUnemployed = fields.occupation[4].toString();
        }
        if (this.hasAdditionalField('location')) {
          result.HomeRegionId = fields.location.data.region_fias_id;
          result.HomeRegionName = fields.location.data.region;
          result.HomeAreaId = fields.location.data.area_fias_id || fields.location.data.city_fias_id || fields.location.data.settlement_fias_id;
          result.HomeAreaName = fields.location.data.area || fields.location.data.city || fields.location.data.settlement;
          result.HomeFull = fields.location.value;
          if (this.saveCityDistrictForHomeAreaId && this.saveCityDistrictForHomeAreaId === result.HomeAreaId) {
            result.CityDistrictName = fields.location.data.city_district;
          }
        }

        if ((this.hasAdditionalField('organization') && fields.union === 'Member' && fields.occupation[1] === true)
          || (this.hasAdditionalFields(['occupation', 'organization']) && fields.occupation[1] === true)
          || (this.hasAdditionalField('organization') && fields.union === 'Member' && !this.hasAdditionalField('occupation'))) {
          const optional = this.isFieldOptional('organization');
          if (optional !== true) {
            result.OrganizationId = fields.organization.data.inn;
            result.OrganizationName = fields.organization.value;
            result.OrganizationRegionId = fields.organization.data.address.data.region_fias_id;
            result.OrganizationRegionName = fields.organization.data.address.data.region;
            result.OrganizationAreaId = fields.organization.data.address.data.area_fias_id || fields.organization.data.address.data.city_fias_id;
            result.OrganizationAreaName = fields.organization.data.address.data.area || fields.organization.data.address.data.city;
            result.OrganizationAddress = fields.organization.data.address.value;
            result.OrganizationOkved = fields.organization.data.okved;
          }
        }

        if (this.hasAdditionalField('tel')) {
          result.Tel = fields.tel.replaceAll(' ', '');
        }
        if (this.hasAdditionalField('union')) {
          result.IsUnionMember = (fields.union === 'Member').toString();
        }
        if (this.hasAdditionalField('unionFriend')) {
          result.IsUnionFriend = (fields.unionFriend === 'Friend').toString();
          if (this.unionFriendIsMember && fields.unionFriend === 'Friend') {
            result.IsUnionMember = 'true';
          }
        }
        if (this.hasAdditionalField('ticket') && fields.union === 'Member') {
          result.UnionMemberTicket = fields.ticket.replaceAll(' ', '');
        }
        if (this.hasAdditionalField('position')) {
          result.Position = fields.position;
        }
        if (this.hasAdditionalField('foundOut')) {
          result.FoundOut = fields.foundOut;
        }
        if (this.hasAdditionalField('internalCode')) {
          result.InternalCode = fields.internalCode;
        }
        if (this.hasAdditionalField('personnelNumber')) {
          result.PersonnelNumber = fields.personnelNumber;
        }
        if (this.hasAdditionalField('region')) {
          result.DivisionGroupId = String(this.selectedRegion);
        }
        if (this.hasAdditionalField('division')) {
          if (this.theme === 'RC') {
            if (this.fields.divisionId) {
              const center = this.divisions.find(
                (item) => String(item.id) === String(this.fields.divisionId),
              );
              if (center && center.name) {
                result.PrimaryRunningCenter = center.name;
              }
            }
          } else {
            result.DivisionId = String(this.fields.divisionId) || '-';
          }
        }
        if (this.hasAdditionalField('director')) {
          result.Director = fields.director;
        }
        if (this.hasAdditionalField('ministry')) {
          result.MinistryId = String(this.fields.ministryId) || '-';
        }
        if (this.hasAdditionalField('hobby') && this.fields.hobby) {
          result.Hobby = this.fields.hobby;
        }
        if (this.hasAdditionalField('cityDistrict')) {
          // CityDistrictName передаем только если выбран реальный район (не пустой и не "100")
          if (this.fields.cityDistrict && this.fields.cityDistrict !== '100') {
            result.CityDistrictName = this.fields.cityDistrict;
          }
          // Хардкод для СПб - всегда передаем эти поля
          result.HomeRegionId = 'c2deb16a-0330-4f05-821f-1d09c93331e6';
          result.HomeRegionName = 'Санкт-Петербург';
          result.HomeAreaId = 'c2deb16a-0330-4f05-821f-1d09c93331e6';
          result.HomeAreaName = 'Санкт-Петербург';
        }
      }

      result.SOPD = fields.agreement.toString();
      result.SOPDDistribution = fields.sopd.toString();
      result.SOPDOffer = fields.sopdDistribution.toString();
      result.SOPDAdvertisement = fields.sopdAdvertisement.toString();

      return result;
    },
    autoJoinTeam() {
      const invitationTeamId = sessionStorage.getItem('invitationTeamId');
      const teamId = this.questionnaire.answers.find((i) => i.key === 'TeamId');
      if (teamId || !invitationTeamId) {
        this.checkQuestionnaire();
        return;
      }

      this.joinTeam(invitationTeamId);
    },
    joinTeam(teamId) {
      const data = { TeamId: teamId };
      this.applyAnswers(data)
        .then(() => {
          if (this.questionnaireStatus === 204) {
            this.checkQuestionnaire();
          }
        });
    },
    getAnswerByKey(key) {
      if (!this.questionnaire.answers || !key) return '';
      const found = this.questionnaire.answers.filter((i) => i.key === key);
      if (found.length === 0) return '';
      return found[0].value;
    },
    getAttributeByKey(attributes, key) {
      if (!attributes || !key) return '';
      const found = attributes.filter((i) => i.key === key);
      if (found.length === 0) return '';
      return found[0].value;
    },
    formatDate(date) {
      return `${date.slice(6)}-${date.slice(3, 5)}-${date.slice(0, 2)}`;
    },
    convertDate(date) {
      if (!date) return '';
      return `${date.slice(8, 10)}.${date.slice(5, 7)}.${date.slice(0, 4)}`;
    },
    convertDateRR(date) {
      if (!date) return '';
      return `${date.slice(3, 5)}.${date.slice(0, 2)}.${date.slice(6, 10)}`;
    },
    convertDateVK(date) {
      if (!date) return '';
      // Поддержка форматов VK: 'DD/MM/YYYY HH:mm:ss' и 'DD/MM/YYYY'
      const d1 = dayjs(date, 'DD/MM/YYYY HH:mm:ss', true);
      if (d1.isValid()) return d1.format('DD.MM.YYYY');
      const d2 = dayjs(date, 'DD/MM/YYYY', true);
      if (d2.isValid()) return d2.format('DD.MM.YYYY');
      // Фоллбэк: ISO 'YYYY-MM-DD[THH:mm:ss]'
      const d3 = dayjs(date, 'YYYY-MM-DD', true);
      if (d3.isValid()) return d3.format('DD.MM.YYYY');
      const d4 = dayjs(date, 'YYYY-MM-DDTHH:mm:ss', true);
      if (d4.isValid()) return d4.format('DD.MM.YYYY');
      return '';
    },
    onDateChange(type) {
      if (type === 1) {
        if (this.fields.date && this.fields.date.length === 10) {
          this.fields.dateMobile = dayjs(this.fields.date, 'DD.MM.YYYY', true).format('YYYY-MM-DD');
        }
      }
      if (type === 2) {
        if (this.fields.dateMobile && this.fields.dateMobile.length === 10) {
          this.fields.date = dayjs(this.fields.dateMobile, 'YYYY-MM-DD', true).format('DD.MM.YYYY');
        }
      }
    },
    onTeamOffLimitsClose() {
      this.teamOffLimits = false;
      this.logout();
    },
    organizationInput() {
      this.isOrganizationSet = false;
      this.isOrganizationNotFound = false;
      if (this.organization !== '') {
        this.debouncedDoSearch();
      } else {
        this.organizationsValues = [];
        this.isOrganizationNotFound = false;
        this.showDropdown = false;
      }
    },
    locationInput() {
      this.isLocationSet = false;
      this.isLocationError = false;
      this.isLocationNoDistrictError = false;
      this.isLocationNotFound = false;
      if (this.location !== '') {
        this.debouncedDoSearch2();
      } else {
        this.locationsValues = [];
        this.isLocationNotFound = false;
        this.showLocationDropdown = false;
      }
    },
    ticketInput() {
      this.isTicketError = false;
    },
    onPersonnelNumberInput(value) {
      let rawValue = '';
      if (typeof value === 'string') {
        rawValue = value;
      } else if (value && value.target) {
        rawValue = value.target.value;
      }
      const digits = String(rawValue || '').replace(/\D/g, '');
      this.fields.personnelNumber = digits;
    },
    doSearchOrganization() {
      if (this.organization === '') return;
      this.backendMessage = null;
      this.searchOrganization(this.organization)
        .then(() => {
          if (this.responseStatus === 200) {
            this.organizationsValues = this.organizations.suggestions;
            this.isOrganizationNotFound = this.organizations.suggestions.length === 0;
            this.showDropdown = true;
            return;
          }
          this.backendMessage = `Произошла ошибка: ${this.responseStatus}`;
          this.organizationsValues = [];
          this.isOrganizationSet = false;
          this.isOrganizationNotFound = false;
          this.showDropdown = false;
        });
    },
    doSearchLocation() {
      if (this.location === '') return;
      this.backendMessage = null;
      this.searchAddress({ query: this.location, locationsBoost: this.locationsBoost })
        .then(() => {
          if (this.responseStatus === 200) {
            this.locationsValues = this.address.suggestions;
            this.isLocationNotFound = this.locationsValues.length === 0;
            this.showLocationDropdown = true;
            return;
          }
          this.backendMessage = `Произошла ошибка: ${this.responseStatus}`;
          this.locationsValues = [];
          this.isLocationSet = false;
          this.isLocationNotFound = false;
          this.showLocationDropdown = false;
        });
    },
    setOrganization(item) {
      this.fields.organization = item;
      this.organization = item.value;
      this.isOrganizationSet = true;
      this.isOrganizationNotFound = false;
      this.showDropdown = false;
    },
    setLocation(item) {
      const id = item.data.area_fias_id || item.data.city_fias_id || item.data.settlement_fias_id;
      if (id === null) {
        this.fields.location = null;
        this.location = '';
        this.isLocationSet = false;
        this.isLocationError = true;
        this.isLocationNoDistrictError = false;
        this.isLocationNotFound = false;
        this.showLocationDropdown = false;
        return;
      }
      if (this.saveCityDistrictForHomeAreaId && this.saveCityDistrictForHomeAreaId === id) {
        if (!item.data.city_district) {
          this.fields.location = null;
          this.location = item.value;
          this.isLocationSet = false;
          this.isLocationError = true;
          this.isLocationNoDistrictError = true;
          this.isLocationNotFound = false;
          this.showLocationDropdown = false;
          return;
        }
      }
      this.fields.location = item;
      this.location = item.value;
      this.isLocationSet = true;
      this.isLocationError = false;
      this.isLocationNoDistrictError = false;
      this.isLocationNotFound = false;
      this.showLocationDropdown = false;
    },
    onOccupationInput() {
      this.occupationError = false;
    },
    submit() {
      if (this.sending) {
        return;
      }
      this.showErrors = true;
      this.occupationError = false;
      this.isTelError = false;
      this.isTicketError = false;
      if (this.showRegisterAdditionalStep || this.showTelOnStep1) {
        if (!this.checkOccupation()) this.occupationError = true;
        if (!this.checkTel()) this.isTelError = true;
        if (!this.checkTicket()) this.isTicketError = true;
      }
      this.$v.$touch();
      if (this.hasErrors || this.occupationError || this.isTelError || this.isTicketError) {
        return;
      }

      // Обычная логика завершения регистрации
      this.sending = true;
      this.backendMessage = null;
      this.applyAnswers(this.getData())
        .then(() => {
          if (this.questionnaireStatus === 204) {
            this.completeQuestionnaire()
              .then(() => {
                if (this.questionnaireStatus === 204) {
                  // Если команды обязательны и это не приватный режим,
                  // перенаправляем на выбор команды ТОЛЬКО при необходимости выбора команды
                  // (например, участник профсоюза или друг, приравненный к члену, для соответствующих тем)
                  if (this.isTeamsEnabled && !this.isTeamStepHidden && !this.isPrivate && this.isTeamStepRequired && this.isNeedToSelectTeam()) {
                    this.$router.push({ name: 'Team' }).catch(() => {});
                  } else if (!this.isPrivate) {
                    this.autoJoinTeam();
                  } else {
                    this.checkQuestionnaire();
                  }
                } else if (this.questionnaireStatus === 409) {
                  this.teamOffLimits = true;
                } else {
                  this.sending = false;
                  this.showErrors = false;
                  this.occupationError = false;
                  this.backendMessage = this.isPhoneTakenError()
                    ? 'Этот номер привязан к другому профилю. Используйте другой номер'
                    : `Произошла ошибка: ${this.questionnaireStatus}`;
                }
              });
          } else {
            this.sending = false;
            this.showErrors = false;
            this.occupationError = false;
            this.backendMessage = this.isPhoneTakenError()
              ? 'Этот номер привязан к другому профилю. Используйте другой номер'
              : `Произошла ошибка: ${this.questionnaireStatus}`;
          }
        });
    },
    isPhoneTakenError() {
      const detail = String(this.questionnaireErrorDetail || '').toLowerCase();
      if (detail.includes('phone') && detail.includes('already exists')) return true;
      if (this.questionnaireErrorCode === 'code_incorrect'
        && (this.showTelOnStep1 || this.hasAdditionalField('tel'))) {
        return true;
      }
      return false;
    },
    checkOccupation() {
      if (!this.hasAdditionalField('occupation')) return true;
      return this.fields.occupation.filter((i) => i === true).length > 0;
    },
    checkTel() {
      if (this.showTelOnStep1) {
        return /^\+7\d{10}$/.test(String(this.fields.tel || ''));
      }
      if (!this.hasAdditionalField('tel')) return true;
      const { tel } = this.fields;
      if (this.isFieldOptional('tel') && (tel === null || tel === '' || String(tel).trim() === '')) return true;
      if (tel === null || tel === '') return false;
      const value = String(tel).replace(/\D/g, '');
      // Формат: ровно 11 цифр, начинается с 8 (89001111213)
      return /^8\d{10}$/.test(value);
    },
    checkTicket() {
      if (!this.hasAdditionalField('ticket') || !this.hasAdditionalField('union')) return true;
      if (this.fields.union === 'NonMember') return true;
      const { ticket } = this.fields;
      if (ticket === null || ticket === '') return false;
      const code = ticket.replaceAll(' ', '');
      return code.length === 16 && code.indexOf('96438090') === 0;
    },
    hasAdditionalField(fieldName) {
      return this.currentAdditionalFields[fieldName] !== undefined;
    },
    hasAdditionalFields(fields) {
      if (!fields) return false;
      for (let i = 0; i < fields.length; i += 1) {
        if (!this.currentAdditionalFields[fields[i]]) return false;
      }
      return true;
    },
    getFieldOrder(fieldName) {
      const field = this.currentAdditionalFields[fieldName];
      if (!field) return 'unset';
      return field.order || 'unset';
    },
    isFieldOptional(fieldName) {
      const field = this.currentAdditionalFields[fieldName];
      if (!field) return null;
      return field.optional === true;
    },
    isOrganizationRequired() {
      const optional = this.isFieldOptional('organization');
      if (optional === true) return false;
      if (this.hasAdditionalField('occupation') && !this.hasAdditionalField('organization')) return false;
      return (!this.hasAdditionalField('occupation') && this.hasAdditionalField('organization') && this.fields.union === 'Member' && this.currentStep === 2)
        || (this.hasAdditionalField('occupation') && this.fields.occupation[1] === true && this.currentStep === 2);
    },
    resetEmail() {
      Cookies.remove('token');
      sessionStorage.removeItem('authFromSSO');
      sessionStorage.removeItem('ssoAccessAttributes');
      this.$router.push({ name: 'Auth' }).catch(() => {});
    },
    resetOrganization() {
      this.organizationsValues = [];
    },
    isNeedToSelectTeam() {
      return this.isTeamsEnabled && !this.isTeamStepHidden && (!this.hasAdditionalField('union')
        || (this.hasAdditionalField('union') && this.fields.union === 'Member')
        || (this.unionFriendIsMember && this.hasAdditionalField('unionFriend') && this.fields.unionFriend === 'Friend'));
    },
    replaceVariables(text) {
      if (!text) return '';
      const vars = [
        { id: 'urlPrefix', value: this.isMobileApp ? `/openInExternal?url=${window.location.origin}` : '' },
      ];
      let result = text;
      for (let i = 0; i < vars.length; i += 1) {
        result = result.replaceAll(`{{${vars[i].id}}}`, vars[i].value);
      }
      return result;
    },
    extractEmailFromJwt(token) {
      try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = atob(base64);
        const jsonPayload = Array.from(decoded).map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join('');
        const payload = JSON.parse(decodeURIComponent(jsonPayload));
        return payload.EmailAddress || payload.email || null;
      } catch (e) {
        return null;
      }
    },

    // Парсинг URL параметров для мобильного приложения
    parseMobileAppParams() {
      const { query } = this.$route;

      // Парсим параметры из URL только если они есть и поля еще не заполнены
      if (query.FirstName && !this.fields.name) {
        this.fields.name = query.FirstName;
      }

      if (query.LastName && !this.fields.surname) {
        this.fields.surname = query.LastName;
      }

      if (query.Birthday && !this.fields.date) {
        // Парсим дату в формате "07/01/1991 00:00:00"
        const birthdayStr = query.Birthday;

        try {
          // Парсим дату вручную, чтобы избежать проблем с американским форматом
          // Формат: "07/01/1991 00:00:00" -> DD/MM/YYYY HH:mm:ss
          const dateTimeParts = birthdayStr.split(' ');
          const datePart = dateTimeParts[0]; // "07/01/1991"
          const [day, month, year] = datePart.split('/');

          // Создаем дату в правильном формате YYYY-MM-DD
          const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
          const date = new Date(isoDate);

          if (!Number.isNaN(date.getTime())) {
            this.fields.date = `${day}.${month}.${year}`;
            this.fields.dateMobile = isoDate;
          }
        } catch (error) {
          // Игнорируем ошибки парсинга даты
        }
      }

      if (query.Gender && !this.fields.gender) {
        const gender = query.Gender;
        // Маппинг значений пола
        if (gender.toLowerCase() === 'male' || gender.toLowerCase() === 'мужской') {
          this.fields.gender = 'Male';
        } else if (gender.toLowerCase() === 'female' || gender.toLowerCase() === 'женский') {
          this.fields.gender = 'Female';
        }
      }
    },
  },
  mounted() {
    if ((this.currentStep === 1 && this.showTelOnStep1) || (this.currentStep === 2 && this.hasAdditionalField('tel'))) {
      this.telRaw = this.fields.tel ?? '';
    }
    this.setClearHandlers();
    this.checkQuestionnaire();
    this.debouncedDoSearch = Debounce(this.doSearchOrganization, 500);
    this.debouncedDoSearch2 = Debounce(this.doSearchLocation, 500);
    this.getMarketingProgramDocuments().catch(() => {
      // Игнорируем ошибки загрузки документов маркетинговой программы
    });

    this.parseMobileAppParams();
  },
};
</script>

<style lang="scss" scoped>
  @import "./PersonalInfo";
</style>
